export default __webpack_public_path__ + "static/eth-5ef8cd5fd4cba9b37ae487d396716741.png";